import Component from "../../lib/component";

export const ProductIntroFootConfig = {
    componentTypeKey: 'ProductIntroFoot',
    baseHtmlClass: 'product_intro__foot',
    selector: '.product_intro__foot',

    optionsSelector: '.product_intro__options',
};

export class ProductIntroFoot extends Component {

    constructor(id_or_element, productIntro) {
        super({
            element: id_or_element,
            config: ProductIntroFootConfig
        });

        this.productIntro = productIntro;

        this.optionsElement = this.element.querySelector(ProductIntroFootConfig.optionsSelector);

        this.render();
    }

    render() {
    }

    hasOptions() {
        return (this.optionsElement && this.optionsElement.children.length > 0)
    }
}

